import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Sandclock",
  "use": "Sandclock-usage",
  "viewBox": "0 0 21 32",
  "content": "<symbol viewBox=\"0 0 21 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Sandclock\">\n<path d=\"M0.153809 0H20.1538V9.6L13.4871 16L20.1538 22.4V32H0.153809V22.4L6.82048 16L0.153809 9.6V0ZM16.8205 23.2L10.1538 16.8L3.48714 23.2V28.8H16.8205V23.2ZM10.1538 15.2L16.8205 8.8V3.2H3.48714V8.8L10.1538 15.2ZM6.82048 6.4H13.4871V7.6L10.1538 10.8L6.82048 7.6V6.4Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol